import React from "react";

export const CompanionForm = ({
  children,
  footerHeight = 70,
  headerHeight = 60,
}) => {
  return (
    <div
      style={{
        "--header-height": `${headerHeight}px`,
        "--footer-height": `${footerHeight}px`,
      }}
    >
      {children}
    </div>
  );
};
